import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function CheckoutPaymentWidget({ responseString }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!responseString || !containerRef.current) {
      return;
    }

    containerRef.current.innerHTML = '';

    containerRef.current.innerHTML = responseString;

    const scripts = containerRef.current.querySelectorAll('script');
    scripts.forEach((script) => {
      const newScript = document.createElement('script');
      newScript.type = 'text/javascript';

      if (script.src) {
        newScript.src = script.src;
        newScript.onerror = () =>
          console.error(
            `CheckoutPaymentWidget: Script failed to load: ${script.src}`
          );
      } else {
        newScript.textContent = script.textContent;
      }

      document.head.appendChild(newScript);
    });
  }, [responseString]);

  if (!responseString) {
    return null;
  }

  return <div ref={containerRef} id="checkout-widget" />;
}

CheckoutPaymentWidget.propTypes = {
  responseString: PropTypes.string,
};

CheckoutPaymentWidget.defaultProps = {
  responseString: '',
};

export default CheckoutPaymentWidget;
